import axios from "axios";
// 添加请求拦截器
axios.interceptors.request.use(function (config: any) {
    // 调试用写成登录
    // window.userAuthority = {
    //     dut: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX3Nlc3Npb25faWQiOjE2ODA1OTQsIm5iX3VzZXJfaWQiOjI4NzQyMzM2LCJleHAiOjE3Mzg3MTk5NzF9.baOeKToUGxdq8_2X3CgHO63V_1aDDGRnPuzy0PfvmFs'
    // }

    // 安卓7版本和以下，会导致window.userAuthority 存不上，通过这个方法来兼容
    if (!window.userAuthority && window.Android && window.Android.getHeader) {
        window.userAuthority = {
            utk: window.Android.getHeader("utk"),
            dut: window.Android.getHeader("dut"),
            sut: window.Android.getHeader("sut")
        };
    }
    // 在发送请求之前做些什么
    if (window.userAuthority) {
        config.headers = {
            // 'x-utk': window.userAuthority.utk,
            ...config.headers
        }
        if (window.userAuthority.utk) {
            config.headers['x-utk'] = window.userAuthority.utk
        }
        if (window.userAuthority.sut) {
            config.headers['x-sut'] = window.userAuthority.sut;
        }
        if (window.userAuthority.dut) {
            config.headers['x-dut'] = window.userAuthority.dut;
        }
    }
    return config;
},  (error) => {
    return Promise.reject(error);
})